import React, { useEffect, useState } from "react";
import { announcementService } from "../../firebase/services";
import { Bell, AlertCircle, Loader2, Calendar, ShieldCheck } from "lucide-react";

export const StudentAnnouncements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const list = await announcementService.getAnnouncements();
        setAnnouncements(list);
      } catch (err) {
        console.error("Announcements load error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, []);

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="border-b border-border pb-4">
        <h1 className="text-2xl font-bold tracking-tight">Official Masterclass Announcements</h1>
        <p className="text-xs text-muted-foreground font-mono">
          Notices, lab access credentials, updates, and instructions from Kian Technologies coordinators.
        </p>
      </div>

      {loading ? (
        <div className="p-12 text-center text-muted-foreground flex flex-col items-center justify-center gap-2">
          <Loader2 className="w-6 h-6 animate-spin text-emerald-400" />
          <span className="text-xs font-mono">Loading announcements from Firestore...</span>
        </div>
      ) : announcements.length === 0 ? (
        <div className="p-12 text-center text-muted-foreground space-y-2 bg-card border border-border rounded-xl">
          <AlertCircle className="w-8 h-8 mx-auto text-muted-foreground/50" />
          <div className="text-sm font-semibold text-foreground">No announcements yet.</div>
          <p className="text-xs max-w-sm mx-auto font-mono">
            Important announcements from the instructor team will be posted here.
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {announcements.map((item) => (
            <div
              key={item.id}
              className={`p-6 rounded-xl bg-card border ${
                item.priority === "urgent"
                  ? "border-rose-500/40 bg-rose-500/5"
                  : item.priority === "important"
                  ? "border-amber-500/40 bg-amber-500/5"
                  : "border-border"
              } space-y-3 shadow-sm`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`text-[10px] font-mono px-2.5 py-0.5 rounded uppercase font-bold border ${
                    item.priority === "urgent"
                      ? "bg-rose-500/10 text-rose-400 border-rose-500/20"
                      : item.priority === "important"
                      ? "bg-amber-500/10 text-amber-400 border-amber-500/20"
                      : "bg-emerald-500/10 text-emerald-400 border-emerald-500/20"
                  }`}
                >
                  {item.priority || "Notice"}
                </span>
                <span className="text-xs font-mono text-muted-foreground flex items-center gap-1">
                  <Calendar className="w-3.5 h-3.5" />
                  {item.createdAt?.toDate
                    ? item.createdAt.toDate().toLocaleString()
                    : "Published"}
                </span>
              </div>

              <h2 className="text-base font-bold text-foreground">{item.title}</h2>
              <p className="text-xs text-muted-foreground leading-relaxed whitespace-pre-line">
                {item.content}
              </p>

              {item.author && (
                <div className="pt-2 border-t border-border/60 text-[11px] font-mono text-muted-foreground flex items-center gap-1.5">
                  <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" />
                  <span>Posted by: {item.author}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
